import { type ReactNode, type FC } from 'react';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

import dibsCss from 'dibs-css';
import cn from 'classnames';

type Props = {
    question: ReactNode;
    children: ReactNode;
    hasTopBorder?: boolean;
};

export const SbSharedMarketTrendsQuestionWrapper: FC<Props> = ({
    question,
    children,
    hasTopBorder = false,
}) => {
    const { isDesktop } = useServerVarsContext();
    return (
        <article
            className={cn(
                dibsCss.flex,
                ...(isDesktop
                    ? [dibsCss.flexRow, dibsCss.gapMedium]
                    : [dibsCss.flexCol, dibsCss.gapSmall]),
                ...(hasTopBorder
                    ? [
                          dibsCss.borderT,
                          dibsCss.borderDolphin,
                          dibsCss.borderTSolid,
                          isDesktop ? dibsCss.ptLarger : dibsCss.ptLarge,
                          isDesktop ? dibsCss.mtLarger : dibsCss.mtLarge,
                      ]
                    : [])
            )}
        >
            <HeadingLevel>
                {Heading => (
                    <>
                        <header className={dibsCss.basis25}>
                            <Heading className={cn(dibsCss.sassyFontBodyLargeHeavy, dibsCss.my0)}>
                                {question}
                            </Heading>
                        </header>
                        <section className={cn(dibsCss.basis75, dibsCss.overflowXAuto)}>
                            {children}
                        </section>
                    </>
                )}
            </HeadingLevel>
        </article>
    );
};
